__turbopack_context__.v({
  "icon": "HeaderLink-module__sad-ba__icon",
  "root": "HeaderLink-module__sad-ba__root",
});
